<fgb-page-header
  [pageTitle]="'rewards.nav.wallet'"
  [backButtonLink]="'/rewards/wallet'"
  [showBalance]="false"
  [showQr]="false"
></fgb-page-header>

<div class="container">
  <div class="d-flex align-items-center pt-lg-4">
    <!-- Back Button -->
    <div class="back-btn bg-primary pb-0 d-none d-lg-flex" [routerLink]="'/rewards/wallet'">
      <span class="material-symbols-outlined text-white"> arrow_back_ios_new </span>
    </div>
  </div>

  <!-- Offer history -->
  <fgb-campaigns-v2-used-offers-list></fgb-campaigns-v2-used-offers-list>

  <!-- Items history -->
  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async,
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <h5 class="m-0 wallet-redeemed-title pt-0">
        {{ 'wallet.redeemed.item.history.title' | translate }}
      </h5>
      <fgbcl-rewards-wallet-redeemed-list
        [redeemedItems]="walletItems.walletItemsClaimed"
        [style]="'list'"
      ></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <h5 class="m-0 wallet-redeemed-title">
    {{ 'wallet.redeemed.item.history.title' | translate }}
  </h5>
  <div class="">
    <div class="border rounded">
      <div class="font-size-12 text-center text-black bg-white rounded py-3">
        {{ 'claimed.rewards.placeholder.description' | translate }}
      </div>
    </div>
  </div>
</ng-template>
